export const breakpoints = {
    sm: '30em',
    md: '48em',
    lg: '64em',
    xl: '90em',
};
